import { useState } from 'react';
import { faqs } from '@/mocks/yihao';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">常见问题</h2>
          <p className="text-foreground-600 text-base">快速了解壹号娱乐平台，解答您的疑问</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/60 bg-background-50 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <h3 className="font-medium text-foreground-800 pr-4">{faq.question}</h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIdx === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`px-6 overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'pb-4 max-h-96' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}